// libraries.
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// interfaces.
export interface StateMedianZones {
  medianZoneCode: string;
  showPolygons?: boolean;
}

export const initialState: StateMedianZones = {
  medianZoneCode: '',
  showPolygons: true,
};

export const domainMedianZonesSlice = createSlice({
  name: 'domainMedianZones',
  initialState,
  reducers: {
    setMedianZoneCode: (state, action: PayloadAction<string>) => {
      state.medianZoneCode = action.payload;
    },
    setShowPolygons: (state, action: PayloadAction<boolean>) => {
      state.showPolygons = action.payload;
    },
    setDefaultState: () => {
      return initialState;
    },
  },
});

export const { setMedianZoneCode, setDefaultState, setShowPolygons } =
  domainMedianZonesSlice.actions;

export default domainMedianZonesSlice.reducer;

// selectors.
export const getMedianZoneCode = (state: {
  domainMedianZones: StateMedianZones;
}) => state.domainMedianZones.medianZoneCode;

export const getShowPolygons = (state: {
  domainMedianZones: StateMedianZones;
}) => state.domainMedianZones.showPolygons;
